import { render, staticRenderFns } from "./CenterSelect.vue?vue&type=template&id=b72ce1d6&scoped=true"
import script from "./CenterSelect.vue?vue&type=script&lang=js"
export * from "./CenterSelect.vue?vue&type=script&lang=js"
import style0 from "./CenterSelect.vue?vue&type=style&index=0&id=b72ce1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ce1d6",
  null
  
)

export default component.exports